export var StudyTranslationLanguage;
(function (StudyTranslationLanguage) {
    StudyTranslationLanguage["en"] = "en";
    StudyTranslationLanguage["es"] = "es";
})(StudyTranslationLanguage || (StudyTranslationLanguage = {}));
